import { ModuleLoader } from './helpers.js';

class ArViewer extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('#ar-dialog');
    this.currentModelSrc = null;
    this.previewIndex = 0;

    this.moveToHigherDomPosition();
    this.bindWindowEvents();
    this.bindDialogEvents();
  }

  showDialog() {
    ModuleLoader.load('https://sneaker-window.vyking.io/vyking-model-viewer/model-viewer.min.js');
    this.insertModelViewer();
    this.dialog.classList.remove('pointer-events-none', 'opacity-0');
    this.fixPageHeight();
  }

  hideDialog() {
    this.dialog.classList.add('pointer-events-none', 'opacity-0');
    this.dialog.querySelector('model-viewer').remove();
    this.unfixPageHeight();
  }

  insertModelViewer() {
    let modelViewer = document.getElementById('model-viewer').content.cloneNode(true);
    modelViewer.querySelector('model-viewer').setAttribute('vyking-src', this.currentModelSrc);

    let poster = modelViewer.querySelector('[slot="poster"] img');
    let posterImg = document.querySelector(`#productGallery [data-swiper-slide-index="${this.previewIndex}"] img`);
    poster.setAttribute('src', posterImg.currentSrc);
    if (window.innerWidth <= 1023) {
      poster.style.height = `${posterImg.getBoundingClientRect().height}px`; // dynamic tailwind height fail
    }

    this.dialog.appendChild(modelViewer);
    this.modelViewer = this.dialog.querySelector('model-viewer');
  }

  fixPageHeight() {
    document.documentElement.classList.add('fixed', 'w-full', 'overscroll-none');
  }

  unfixPageHeight() {
    document.documentElement.classList.remove('fixed', 'w-full', 'overscroll-none');
  }

  moveToHigherDomPosition() {
    document.documentElement.appendChild(this);
  }

  bindModelViewerEvents() {
    const progressBar = this.modelViewer.querySelector('progress');
    this.modelViewer.addEventListener('progress', (ev) => {
      progressBar.value = ev.detail.totalProgress;
    });

    this.modelViewer.addEventListener('load', function (ev) {
      const loader = this.querySelector('.loader');
      loader.remove();
      progressBar.remove();
    });
  }

  bindDialogEvents() {
    this.querySelector('.ar-viewer-close').addEventListener('click', (ev) => {
      this.hideDialog();
    });
    this.dialog.addEventListener('keyup', (ev) => {
      if (ev.key === 'Escape') {
        ev.preventDefault();
        this.hideDialog();
      }
    });
  }

  bindWindowEvents() {
    window.addEventListener('arviewer:showmodel', (ev) => {
      this.currentModelSrc = ev.detail;
      this.showDialog();
      this.bindModelViewerEvents();
    });

    window.addEventListener('product:active-image-change', (ev) => {
      if (ev.detail !== this.previewIndex) {
        this.previewIndex = Number.isInteger(parseInt(ev.detail)) ? ev.detail : 0;
      }
    });
  }
}

window.customElements.define('ar-viewer', ArViewer);
